import { StateCompliance } from '@common/types';
import { CapitolaClient } from './base';

export class StateComplianceClient extends CapitolaClient<StateCompliance> {
  public get resourceName(): string {
    return 'state-compliance';
  }
}
